import type { LabelProps } from "@uhg-harmony/react";
export { Label, type LabelProps } from "@uhg-harmony/react";

export const labelDefaults: LabelProps = {
  isLarge: true,
  required: false,
  forLegend: false,
  children: "",
  asProp: "label",
  className: "",
  tooltip: false,
  tooltipPlacement: undefined,
  tooltipContent: undefined,
  tooltipFontSize: undefined,
};
